<template>
  <div class="player-container d-flex align-center justify-end" @click.stop>
    <v-btn
      v-if="!audioUrl"
      color="primary"
      icon="mdi-play-circle"
      :loading="isLoadingAudio"
      size="small"
      variant="text"
      @click="loadAndPlayAudio"
    />

    <audio
      v-else
      autoplay
      class="compact-audio"
      controls
      :src="audioUrl"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import { deviceRepository } from '@/api/repository/device.repository.ts'
  import { messageRepository } from '@/api/repository/message.repository.ts'
  import { ToastType, useToastStore } from '@/stores/toast.store.ts'

  const props = defineProps<{
    messageId: string
  }>()

  const toastStore = useToastStore()

  const isLoadingAudio = ref(false)
  const audioUrl = ref<string | null>(null)

  /**
   * Fetches the signed URL from the API and reveals the audio player
   */
  async function loadAndPlayAudio () {
    isLoadingAudio.value = true

    try {
      const response = await messageRepository.getMessageAudioLink(props.messageId)
      audioUrl.value = response.url
    } catch {
      toastStore.notify('Impossible de charger le fichier audio', ToastType.Error)
    } finally {
      isLoadingAudio.value = false
    }
  }
</script>
<style scoped>
.player-container {
  width: 100%;
}

.compact-audio {
  height: 40px;
  width: 100%;
  outline: none;
}

@media (min-width: 600px) {
  .player-container {
    width: 300px;
    flex-shrink: 0;
  }
}
</style>
